const is_empty = (x) => x == null || x === "";

// Community DataGrid force disableMultipleColumnsSorting nên sort_model chỉ có
// tối đa 1 cột.
export function applySortModel(rows, sort_model) {
  if (rows == null) return rows;
  if (!Array.isArray(sort_model) || sort_model.length === 0) return rows;

  const { field, sort } = sort_model[0];
  if (field == null || sort == null) return rows;

  const dir = sort === "desc" ? -1 : 1;

  return [...rows].sort((a, b) => {
    const va = a[field];
    const vb = b[field];

    // Ô trống luôn nằm cuối, cả khi sort desc, để không chiếm đầu bảng.
    const ea = is_empty(va);
    const eb = is_empty(vb);
    if (ea && eb) return 0;
    if (ea) return 1;
    if (eb) return -1;

    // Mọi cột của bảng booking đều là chuỗi, kể cả ngày ("YYYY/MM/DD" so sánh
    // chuỗi là so sánh ngày). numeric để booking REF có số sắp đúng thứ tự.
    return (
      dir * String(va).localeCompare(String(vb), "vi", { numeric: true })
    );
  });
}
